<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <unitList
      color="#FF978E"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="list"
    ></unitList>
    <doubleImageAndText
      id="next"
      img="archi3Shadow.png"
      img2="archi2.png"
      title="partenariat c’est quoi ?"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que l’opérateur sait au premier coup d’oeil que la page contenant ces lignes n’est pas valide, et surtout l’attention du client n’est pas dérangée par le contenu, il demeure concentré seulement sur l’aspect graphique."
    ></doubleImageAndText>
    <crew
      color="#FF978E"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="crew"
    ></crew>
  </div>
</template>

<script>
import topPage from "../components/topPage";
import unitList from "../components/unitList";
import doubleImageAndText from "../components/doubleImageAndText";
import crew from "../components/crew";
export default {
  name: "Transaction",
  components: { topPage, unitList, doubleImageAndText, crew },
  data: () => ({
    title: "Transaction",
    bgImg: "transac_illu.png",
    crew: [
      { img: "test.png", title: "test", text: "test" },
      { img: "test.png", title: "test", text: "test" },
      { img: "test.png", title: "test", text: "test" },
      { img: "test.png", title: "test", text: "test" }
    ],
    list: [
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      }
    ]
  })
};
</script>
